import { BsTelephone, BsXLg } from 'react-icons/bs';

import FloatingActionButton from '#globalComponents/FloatingActionButton/FloatingActionButton';
import IconButton from '#globalComponents/IconButton/IconButton';

import { useAircallEverywhereStore } from '../../stores/aircallEverywhereStore';

import { useCallingMode } from './useAircallEverywhere';

const AIRCALL_DOM_ID = 'aircall-everywhere-root';
const WIDGET_WIDTH = 376;
const WIDGET_HEIGHT = 666;

/**
 * Controls the visibility of the Aircall Everywhere iframe.
 * The iframe DOM node always stays rendered at full size — toggling only
 * changes CSS visibility so that the Twilio/WebRTC session is never destroyed.
 *
 * The SDK container is always in the DOM (even before login) so the SDK can
 * initialize and fire onLogin. Only the panel chrome and toggle button require login.
 */
const AircallPhoneWidget = () => {
	const callingMode = useCallingMode();
	const isLoggedIn = useAircallEverywhereStore((s) => s.isLoggedIn);
	const widgetVisible = useAircallEverywhereStore((s) => s.widgetVisible);
	const setWidgetVisible = useAircallEverywhereStore((s) => s.setWidgetVisible);

	// SDK container must always be in the DOM for initialization.
	// Panel chrome + toggle button only appear after login.
	const showControls = callingMode === 'everywhere' && isLoggedIn;
	const panelVisible = showControls && widgetVisible;

	return (
		<>
			<div
				className={`fixed z-[51] shadow-elevated rounded-card overflow-hidden border border-bgBase-500 bg-white transition-opacity duration-200 ${
					panelVisible ? 'visible opacity-100' : 'invisible opacity-0 pointer-events-none'
				}`}
				style={{
					top: '32px',
					right: '16px',
					width: `${WIDGET_WIDTH}px`,
					height: `${WIDGET_HEIGHT}px`,
					maxHeight: 'calc(100vh - 136px)',
				}}
			>
				<div className="flex items-center justify-between px-3 py-2 bg-bgBase-300 border-b border-bgBase-500">
					<div className="flex items-center gap-2">
						<BsTelephone className="w-3.5 h-3.5 text-primary-700" />
						<span className="text-xs font-semibold text-text">Aircall</span>
					</div>
					<IconButton
						icon={BsXLg}
						label="Aircall Telefon schließen"
						onClick={() => setWidgetVisible(false)}
						className="h-6 w-6"
					/>
				</div>
				{/* SDK iframe mount point — never unmounted */}
				<div id={AIRCALL_DOM_ID} className="w-full" style={{ height: `${WIDGET_HEIGHT - 36}px` }} />
			</div>

			{/* Toggle button — only after login */}
			{showControls && (
				<div className="fixed bottom-6 z-[52]" style={{ right: '100px' }}>
					<FloatingActionButton
						onClick={() => setWidgetVisible(!widgetVisible)}
						pressed={widgetVisible}
						title={widgetVisible ? 'Aircall Telefon schließen' : 'Aircall Telefon öffnen'}
					>
						{widgetVisible ? <BsXLg className="w-6 h-6" /> : <BsTelephone className="w-6 h-6" />}
					</FloatingActionButton>
				</div>
			)}
		</>
	);
};

export default AircallPhoneWidget;
